/* Collection description: clamp to 3 lines on phones with a Read more toggle. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  document.querySelectorAll('.collection-hero__description').forEach(function (el) {
    el.classList.add('vys-clamp');
    if (el.scrollHeight <= el.clientHeight + 4) { el.classList.remove('vys-clamp'); return; }
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'vys-more'; b.textContent = 'Read more';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = el.classList.toggle('vys-clamp') === false;
      b.textContent = open ? 'Show less' : 'Read more';
      b.setAttribute('aria-expanded', open);
    });
    el.insertAdjacentElement('afterend', b);
  });
})();
